module.exports = __webpack_public_path__ + "static/media/aygun4.15df262c.webp";